import './App.css';
import {Route, BrowserRouter, Routes, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import PasswordReset from './pages/PasswordReset';
import Home from './pages/Home';
import CarDetails from './pages/CarDetails';
import BookingCar from './pages/BookingCar';
import UserBookings from './pages/UserBookings';
import AdminHome from './admin/AdminHome';
import Cars from './admin/Cars';
import AddCar from './admin/AddCar';
import Customers from './admin/Customers';
import Bookings from './admin/Bookings';
import UploadDemo from './pages/UploadDemo';
import EditCar from './admin/EditCar';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Missing from './components/Missing';
import 'antd/dist/antd.css'; 

function App() {
    return (
        <BrowserRouter>
            <div className="App">
                <Routes>
                    {/* Public Routes */}
                    <Route path='/' element={<Landing />}/>
                    <Route path='/home' element={<Home/>}/>
                    <Route path='/cardetails/:id' element={<CarDetails/>}/>
                    <Route path="/login" element={<Login/>} />
                    <Route path="/register" element={<Register/>} />
                    <Route path="/passwordreset" element={<PasswordReset/>} />
                    <Route path='/about' element={<About/>}/>
                    <Route path='/services' element={<Services/>}/>
                    <Route path='/contact' element={<Contact/>}/>
                    <Route path='/privacy' element={<Privacy/>}/>
                    <Route path='/terms' element={<Terms/>}/>

                    {/* Protected Routes */}
                    <Route path='/booking/:id' element={ <PrivateRoute><BookingCar /></PrivateRoute> } />
                    <Route path='/userbookings' element={ <PrivateRoute><UserBookings /></PrivateRoute>} />
                   
                    <Route path='/admin/*' element={ <PrivateRoute><AdminHome /></PrivateRoute> } >

                        <Route path='cars' element={ <PrivateRoute><Cars /></PrivateRoute> } />

                        <Route path='addcar' element={ <PrivateRoute><AddCar /></PrivateRoute> } />

                        <Route path='customers' element={ <PrivateRoute><Customers /></PrivateRoute> } />

                        <Route path='bookings' element={ <PrivateRoute><Bookings /></PrivateRoute> } />

                        <Route path='uploads' element={ <PrivateRoute><UploadDemo /></PrivateRoute> } />

                        <Route path='editcar/:id' element={ <PrivateRoute><EditCar /></PrivateRoute>} />

                    </Route>
                    {/* <Route path='/editcar/:id' element={ <PrivateRoute><EditCar /></PrivateRoute>} /> */}

                    {/* catch all */}
                    <Route path="*" element={<Missing />} />

                </Routes>
            </div>
        </BrowserRouter>
    );
}

export default App;

export function PrivateRoute({ children }) {
    if(localStorage.getItem('user'))
    {
        return children;
    }
    else{
        return <Navigate to='/login' replace={true} />;
    }
}
